// AfishaSlider.js (обновленная версия)
import { Swiper, SwiperSlide } from 'swiper/react';
import { format } from "date-fns";
import { ru } from "date-fns/locale";
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';
import { FreeMode, Scrollbar, Navigation } from 'swiper/modules';
import { Link, useSearchParams } from 'react-router-dom';
import { ImageLoader } from '../UI/ImageLoader';
import { Button, Col, Modal, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useEffect, useRef, useState } from 'react';
import { Cash, Clock } from 'react-bootstrap-icons';
import { ButtonAfisha } from '../UI/AfishaItem';
import { ShowSchedulesItem } from '../UI/ShowSchedulesItem';

export const BuyButton = ({ item }) => {
    const [t] = useTranslation("global");
    const [showModel, setShowModel] = useState(false)
    const [dateList, setDateList] = useState()
    const [searchParams, SetSearchParams] = useSearchParams();

    const setParam = (seoUrl) => {
        searchParams.set("showModal", 'true')
        searchParams.append("selectShow", seoUrl)
        SetSearchParams(searchParams)
    }
    const hideModal = () => {
        setShowModel(false)
        searchParams.delete("selectShow")
        searchParams.delete("showModal")
        SetSearchParams(searchParams)
        setDateList(null)
    }

    useEffect(() => {
        if (searchParams.get('showModal') === 'true') {
            setShowModel(true)
        }
    }, [])

    return (
        <>
            <Modal
                show={showModel}
                size="md"
                fullscreen={"sm-down"}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                onHide={() => hideModal()}
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        {t("afisha.selectdate")}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {dateList &&
                        <>
                            {dateList.map(item =>
                                <ShowSchedulesItem key={item.id} item={item} />
                            )}
                        </>
                    }
                </Modal.Body>
            </Modal>
            <ButtonAfisha item={item} setShowModel={setShowModel} setParam={setParam} hideModal={hideModal} searchParams={searchParams} setDateList={setDateList} />
        </>
    )
}

// Обновленный DateBtn в стиле премьеры
export const DateBtn = ({ schedule }) => {
    const date = new Date(schedule.startOfEvent);

    return (
        <Link to={`/paytickets/session?sessionsId=${schedule.sessionTPId}`} className='text-decoration-none'>
            <div className="afisha-date-btn">
                <div className="date-day">{format(date, 'dd', { locale: ru })} <span className="date-month">{format(date, 'MMM', { locale: ru }).slice(0, 3).replace(".", "")}</span></div>
                {/* <div className="date-month"></div> */}
                <div className="date-time">{format(date, 'HH:mm')}</div>
            </div>
        </Link>
    );
};

// Компонент информационной строки (премиальный стиль)
export const InfoLine = ({ ageCategory, duration, stage }) => (
    <div className="afisha-info-line flex-wrap align-items-center justify-content-center">
        <span className="divider d-flex align-items-center gap-1">
            {/* <svg width={14} height={14}>
                <use xlinkHref='lc-logo.svg#stage' fill='currentColor'></use>
            </svg> */}
            {stage}
        </span>
    </div>
);

// Компонент карточки события
const EventCard = ({ item, isMobile = false }) => {
    const refImg = useRef(null);
    // const isPremiere = item.showSchedules?.[0]?.nameInPremiera || false;

    return (
        <div className="afisha-card">
            {/* Бейдж премьеры */}
            {/* {isPremiere && (
                <div className="premiere-badge">ПРЕМЬЕРА</div>
            )} */}

            <Link to={`/about-project/show/${item.seoUrl}`} className='link-decor'>
                <div className='position-relative text-center overflow-hidden'>
                    <ImageLoader
                        ref={refImg}
                        src={`https://leningradcenter.ru/api/shows/afisha-img/${item.id}`}
                        name={item.name}
                        mHeight={isMobile ? '50vh' : '65vh'}
                        className="card-image"
                    />
                </div>
            </Link>

            <div className="card-content">
                <Link to={`/about-project/show/${item.seoUrl}`} className='link-decor'>
                    <div className="afisha-title">{item.name}</div>
                    {/* {item.buttonType === 0 && item.showSchedules?.length > 0 && (
                        <div className="afisha-price mb-1">
                            Стоимость <span className="price-value">{price}</span>
                        </div>
                    )} */}
                </Link>

                <InfoLine
                    ageCategory={item.ageCategory}
                    duration={item.showSchedules?.[0]?.duration}
                    stage={item.stage}
                />

                {item.buttonType === 0 && item.showSchedules?.length > 0 && (
                    <div>
                        {/* <p className="afisha-date-label">Выберите дату</p> */}
                        <div className="d-flex flex-wrap gap-1 mb-2">
                            {item.showSchedules.map((date) => (
                                <DateBtn key={date.id} schedule={date} />
                            ))}
                            {/* {item.showSchedules.length > 5 && (
                                <span className="afisha-more-dates">+{item.showSchedules.length - 5}</span>
                            )} */}
                        </div>
                    </div>
                )}

                <div className="d-flex align-items-center justify-content-between flex-fill">
                    <BuyButton item={item} />
                </div>
            </div>
        </div>
    );
};

// AfishaSlider — десктопная версия
export const AfishaSlider = ({ items }) => {
    const [t] = useTranslation("global");
    const refImg = useRef(null);

    const sizeSlider = () => {
        const itemsSize = items.length
        return {
            '@0.00': {
                slidesPerView: itemsSize > 1 ? 1.2 : itemsSize,
                centeredSlides: false,
                spaceBetween: 20,
            },
            '@0.75': {
                slidesPerView: itemsSize > 1 ? 1.4 : itemsSize,
                centeredSlides: false,
                spaceBetween: 30,
            },
            '@1.00': {
                slidesPerView: itemsSize > 3 ? 3.2 : itemsSize,
                centeredSlides: false,
                spaceBetween: 30,
            },
            '@1.50': {
                slidesPerView: itemsSize > 3 ? 4.2 : itemsSize,
                centeredSlides: false,
                spaceBetween: 40,
            },
            '@2.00': {
                slidesPerView: itemsSize > 3 ? 4.2 : itemsSize,
                centeredSlides: false,
                spaceBetween: 50,
            },
        }
    }

    return (
        <Swiper
            slidesPerView={'auto'}
            spaceBetween={30}
            scrollbar={true}
            navigation={true}
            modules={[Scrollbar, FreeMode, Navigation]}
            className="afisha-swiper justify-content-center"
            breakpoints={sizeSlider()}
            slidesOffsetBefore={items.length > 2 ? 20 : 0}
            slidesOffsetAfter={items.length > 2 ? 20 : 0}
        >
            {items.length < 2 ?
                <>
                    {items.map((item) => (
                        <Row className='justify-content-md-center'>
                            <Col>
                                <Link to={`/about-project/show/${item.seoUrl}`} className='link-decor'>
                                    <div className='position-relative text-center'>
                                        <div className='d-md-none'>
                                            <ImageLoader src={`/api/shows/afisha-img/${item.id}`} name={item.name} mHeight={'60vh'} />
                                            {/* <Image alt={item.name} className='' src={`/api/shows/afisha-img/${item.id}`} fluid style={{ maxHeight: "60vh" }} /> */}
                                        </div>
                                        <div className='d-none d-md-block'>
                                            <ImageLoader src={`/api/shows/head-img/${item.id}`} wide={true} name={item.name} mHeight={'70vh'} />
                                            {/* <Image alt={item.name} src={`/api/shows/head-img/${item.id}`} fluid style={{ maxHeight: "70vh" }} /> */}
                                        </div>
                                    </div>
                                </Link>
                            </Col>
                            <Col lg={4}>
                                <Link to={`/about-project/show/${item.seoUrl}`} className='link-decor'>
                                    <h3 className='afisha-event-title mt-3 mb-0'>
                                        <strong>{item.name}</strong>
                                    </h3>
                                    <p>
                                        <strong>
                                            {item.shortDescription}
                                        </strong>
                                    </p>
                                    <InfoLine
                                        ageCategory={item.ageCategory}
                                        duration={item.showSchedules?.[0]?.duration}
                                        stage={item.stage}
                                    />
                                </Link>
                                <div>
                                    {item.buttonType === 0 && item.showSchedules?.length > 0 && (
                                        <div>
                                            {/* <p className="afisha-date-label">Выберите дату</p> */}
                                            <div className="d-flex flex-wrap gap-1 mb-2">
                                                {item.showSchedules.map((date) => (
                                                    <DateBtn key={date.id} schedule={date} />
                                                ))}
                                                {/* {item.showSchedules.length > 5 && (
                                                    <span className="afisha-more-dates">+{item.showSchedules.length - 5}</span>
                                                )} */}
                                            </div>
                                        </div>
                                    )}

                                    <div className="d-flex align-items-center justify-content-between flex-fill">
                                        <BuyButton item={item} />
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    )
                    )}
                </> : <>
                    {items.map((item) => (
                        <SwiperSlide key={item.id} className='mb-3 afisha-swiper-slide'>
                            <div className='position-relative' style={{ maxWidth: '400px', margin: '0 auto' }}>
                                <EventCard item={item} isMobile={false} />
                            </div>
                        </SwiperSlide>
                    ))}
                </>
            }
        </Swiper>
    );
};